import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { AssetsService } from "../services/AssetsService";
const styles = StyleSheet.create({
  header: {
    color: "#898989",
    padding: 20,
    display: "flex",
    flexDirection: "row",
  },
  headerLeft: {
    textAlign: "left",
    flex: 1,
    alignSelf: "center",
    fontSize: 32,
    fontWeight: 900,
    lineHeight: 1,
    color: "#0084B4",
    fontFamily: "KadwaBold",
  },
  image: {
    height: 80,
    width: 150,
  },
  headerRight: {
    textAlign: "right",
    fontSize: 12,
    flex: 1,
    fontFamily: "MontserratRegular",
  },
});

function PDFCompanyHeader(props: any) {
  const [image, setImage] = useState("");
  const [imageType, setImageType] = useState("");
  useEffect(() => {
    let assetsService: AssetsService = new AssetsService();
    let fileExt = "png";
    if (
      props.company &&
      props.company.imageItem &&
      props.company.imageItem.filename
    ) {
      fileExt = props.company.imageItem.filename.substr(
        props.company.imageItem.filename.lastIndexOf(".") + 1
      );
    }
    assetsService.getAsset(props.company.imageItem.filename).then((resp) => {
      if (resp && resp.success && resp.data) {
        setImage(resp.data);
        setImageType(fileExt);
      }
    });
  });

  return (
    <View style={styles.header} fixed>
      <View style={styles.headerLeft}>
        <Image
          style={styles.image}
          src={{
            data: new Buffer(image, "base64"),
            format: imageType === "png" ? "png" : "jpg",
          }}
        />
      </View>
      <View style={styles.headerRight}>
        <Text>{props.company ? props.company.name : ""}</Text>
        <Text>
          {props.company && props.company.line1 ? props.company.line1 : ""}
        </Text>
        <Text>
          {props.company && props.company.line2 ? props.company.line2 : ""}
        </Text>
        <Text>
          {props.company && props.company.city ? props.company.city : ""}
        </Text>
        <Text>
          {props.company &&
          props.company.province &&
          props.company.province.label
            ? props.company.province.label
            : ""}
        </Text>

        <Text>
          {props.company && props.company.email ? props.company.email : ""}
        </Text>
        <Text>
          {props.company && props.company.phone ? props.company.phone : ""}
        </Text>
      </View>
    </View>
  );
}
export default PDFCompanyHeader;
